<template>
       <!-- Add Account Modal -->
    <div class="modal worli-Bets-Modal" id="acc-open-model" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header headerTheme">
                    <h5 class="modal-title">{{$t('add-account', 'Add account')}}</h5>
                </div>
                <div class="modal-body add_bank_acc_form">
                    <div class="p-0">
                        <div class="acc-login-form-sec" v-if="paymentMethodList">
                            <label>{{ $t('payment-method', 'Payment Method') }}</label>
                            <select @change="onPaymentMethodChange" v-model="paymentMethodId" class="form-select form-control">
                                <option value="null">---{{ $t('select-payment-method', 'Select Payment Method') }}---</option>
                                <option v-for="(item, index) in paymentMethodList" :key="index" :value="item.id" >{{ item.method_name }}</option>
                            </select>
                        </div>
                            
                        <template v-if="type === 'bank'">
                            <div class="acc-login-form-sec" v-if="filteredBankList">
                                <div class="select-payment-list">
                                    <div class="dropdown bank-dropdown">
                                        <button class="bank-dropdown-input" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{  selectedBank ? selectedBank : $t('select-bank-name', 'Select Bank Name') }}
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <div class="search-input">
                                                <input type="search" v-model="searchBank" class="form-control" placeholder="Search Banks...">
                                            </div>
                                            <li v-for="(item, index) in filteredBankList" :key="index" v-if="filteredBankList && filteredBankList.length">
                                                <a class="dropdown-item" @click="selectBank(item)">{{ item.bank_name }}</a>
                                            </li>
                                            <li v-else>
                                                <a class="dropdown-item">{{$t('no-data-found','No data found')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <p v-if="v$.accountForm.bankId.$error" class="wallet-error">{{ $t('please-select-bank-name', 'Please Select Bank Name') }}.</p>
                            </div>
                            <div class="acc-login-form-sec">
                                <label>{{ $t('account-holder-name', 'Account Holder’s Name') }}</label>
                                <input type="text" v-model="accountForm.account_holder_name" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name*')" class="form-control">
                                <template v-if="v$.accountForm.account_holder_name?.$error && accountForm.account_holder_name == ''">
                                    <p class="error_cl">{{$t('please-enter-name','Account holder name is required.')}}</p>
                                </template>
                                <template v-else-if="v$.accountForm.account_holder_name?.minLength.$invalid || v$.accountForm.account_holder_name?.maxLength.$invalid">
                                    <p class="error_cl">{{$t('min-characters','Account holder name must be 3-100 characters.')}}</p>
                                </template>
                                <template v-if="v$.accountForm.account_holder_name?.alphaName.$invalid">
                                    <p class="error_cl">{{$t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.')}}</p>
                                </template>
                            </div>
                            <div class="acc-login-form-sec">
                                <label>{{ $t('ac-number', 'A/C Number') }}</label>
                                <input v-model="accountForm.account_no" maxlength="18" type="tel" :placeholder="$t('enter-ac-Number', 'Enter A/C Number*')"
                                @input="accountForm.account_no = accountForm.account_no.replace(/\D/g, '')" inputmode="numeric" class="form-control">
                                <p v-if="v$.accountForm.account_no.$error && accountForm.account_no == ''" class="error_cl">{{ $t('please-enter-ac-number', 'Account number is required') }}.</p>
                                <p v-else-if="v$.accountForm.account_no.$error && accountForm.account_no != ''" class="error_cl">Account Number must be a valid numeric value between 9 to 18 digits</p>
                            </div>
                            <div class="acc-login-form-sec">
                                <label>{{ $t('ifsc-code', 'IFSC Code') }}</label>
                                <input v-model="accountForm.ifsc_code" type="text" @input="accountForm.ifsc_code = accountForm.ifsc_code.toUpperCase()" maxlength="11"  :placeholder="$t('enter-ifsc-code', 'Enter IFSC Code')" class="form-control">
                                <p v-if="v$.accountForm.ifsc_code.$error && accountForm.ifsc_code == ''" class="error_cl">{{ $t('please-enter-ifsc-code', 'IFSC Code is required') }}.</p>
                                <p v-if="v$.accountForm.ifsc_code?.ifscValidator.$invalid" class="error_cl">IFSC code should be 11 Alphanumeric Characters</p>
                            </div>
                        </template>
                        <template v-if="type === 'upi' || type === 'wallet'">
                            <div class="acc-login-form-sec">
                                <label>{{ $t('account-holder-name', 'Account Holder’s Name') }}</label>
                                <input v-model="accountForm.account_holder_name"  type="text" class="form-control" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name*')"/>
                                <template v-if="v$.accountForm.account_holder_name?.$error && accountForm.account_holder_name == ''">
                                    <p class="error_cl">{{$t('please-enter-name','Account holder name is required.')}}</p>
                                </template>
                                <template v-else-if="v$.accountForm.account_holder_name?.minLength.$invalid || v$.accountForm.account_holder_name?.maxLength.$invalid">
                                    <p class="error_cl">{{$t('min-characters','Account holder name must be 3-100 characters.')}}</p>
                                </template>
                                <template v-if="v$.accountForm.account_holder_name?.alphaName.$invalid">
                                    <p class="error_cl">{{$t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.')}}</p>
                                </template>
                            </div>


                            <template v-if="type === 'upi'">
                                <div class="acc-login-form-sec">
                                    <label>{{ $t('upi-id', 'UPI ID') }}</label>
                                    <input v-model="accountForm.upi_id" class="form-control profit-input" type="text" :placeholder="$t('enter-upi-id', 'Enter UPI ID')">
                                    <template v-if="accountForm.upi_id != '' && v$.accountForm.upi_id.$error && v$.accountForm.upi_id.minLength.$invalid || v$.accountForm.upi_id.maxLength.$invalid">
                                        <p class="error_cl">{{  $t('upi-length','UPI ID must be 5 to 50 characters.')  }}</p>
                                    </template>
                                    <template v-if="accountForm.upi_id != '' && v$.accountForm.upi_id.$error && v$.accountForm.upi_id.upiValidator.$invalid">
                                        <p class="error_cl">{{$t('upi-format','Must be in the format of name@bank.')}}</p>
                                    </template>
                                </div>
                            </template>

                            <template v-if="type === 'wallet'">
                                <div class="acc-login-form-sec">
                                    <label>{{ $t('wallet-id', 'Wallet ID') }}</label>
                                    <input v-model="accountForm.wallet_id" class="form-control profit-input" type="text" :placeholder="$t('enter-wallet-id', 'Enter wallet ID*')">
                                    <div class="wallet-error" v-if="v$.accountForm.wallet_id.$error">
                                        <template v-if="v$.accountForm.wallet_id.$error && accountForm.wallet_id == ''">
                                            <p class="error_cl">{{ $t('wallet-required','Wallet ID is required.') }}</p>
                                        </template>
                                        <template v-else-if="v$.accountForm.wallet_id.$error && v$.accountForm.wallet_id.minLength.$invalid || v$.accountForm.wallet_id.maxLength.$invalid">
                                            <p class="error_cl">{{ $t('wallet-length','Wallet ID must be 8 to 20 characters.') }}</p>
                                        </template>
                                        <template v-if="v$.accountForm.wallet_id.$error && v$.accountForm.wallet_id.walletValidator.$invalid">
                                            <p class="error_cl">{{$t('wallet-format','Must contain only letters, numbers, hyphens, @ or underscores.')}}</p>
                                        </template>
                                    </div>
                                </div>
                            </template>

                            <div class="acc-login-form-sec" v-if="!previewImageUtr"> 
                                <label class=" info-sec">{{ $t('qr-code-upload-screenshot', 'QR Code (Upload Screenshot)') }} 
                                    <span class="info-sec-icon add_bank_info">
                                        <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy">
                                        <div class="info-list">
                                            <ul>
                                                <li>1. Upload A Screenshot Of A Valid QR Code To Proceed.</li>
                                                <li>2. If the QR code is not detected, the exchange will not be responsible for the losses.</li>
                                            </ul>
                                        </div>
                                    </span>
                                </label>
                                <div class="file-upload-sec withdraw_file_upload_sec">
                                    <label for="file"  class="file-upload">
                                        <span><img src="@/assets/images/file-icon.webp" alt="file-icon" loading="lazy"></span>
                                        <h6>{{ $t('file-upload', 'File Upload') }}</h6>
                                    </label>
                                    <input class="form-control profit-input d-none" ref="fileInput" type="file" id="file" @change="fileUpdateFunc">
                                </div>
                                <div class="file-uploaded" v-if="accountForm.qr_code">
                                    <span class="file-uploaded-title">{{ accountForm.qr_code.name }}</span>
                                    <span class="file-uploaded-cross" @click="accountForm.qr_code = null">&#10006;</span>
                                </div>
                            </div>
                            <div class="acc-login-form-sec" v-if="previewImageUtr">
                                <label>{{ $t('qr-code', 'QR Code') }}</label>
                                <div class="fileList deposit-previewImage">
                                    <img loading="lazy" class="fileList-img" :src="previewImageUtr" alt="file-list"/>
                                    <button class="add-utr-again" @click="clearPaymentSlip()">
                                        &#10006;
                                    </button>
                                    <div class="fileList-loader" v-if="loading">
                                        <div class="loader">
                                            <div class="sk-fading-circle">
                                                <div class="sk-circle1 sk-circle"></div>
                                                <div class="sk-circle2 sk-circle"></div>
                                                <div class="sk-circle3 sk-circle"></div>
                                                <div class="sk-circle4 sk-circle"></div>
                                                <div class="sk-circle5 sk-circle"></div>
                                                <div class="sk-circle6 sk-circle"></div>
                                                <div class="sk-circle7 sk-circle"></div>
                                                <div class="sk-circle8 sk-circle"></div>
                                                <div class="sk-circle9 sk-circle"></div>
                                                <div class="sk-circle10 sk-circle"></div>
                                                <div class="sk-circle11 sk-circle"></div>
                                                <div class="sk-circle12 sk-circle"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="acc-login-form-sec" v-if="type">
                            <label for="nameInput">{{ $t('withdrawal-password', 'Withdrawal Password') }}<span class="star_req">*</span></label>
                            <div class="fill_con">
                                <input :type="passwordFieldType"  v-model="accountForm.withdrawal_password" @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password, 20)"  
                                :placeholder="$t('enter-withdrawal-password', 'Enter Withdrawal Password')" class="form-control password-input" />
                                <!-- <div class="score-hide-show" @click="togglePasswordVisibility('passwordField')">
                                    <img  rel="preload" v-if="passwordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                    <img  rel="preload" v-else src="@/assets/images/eye-open.webp" alt="">
                                </div> -->
                                <div class="showHide-pass">
                                    <i @click="togglePasswordVisibility('passwordField')" class="fa-solid" :class="passwordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </div>
                            </div>
                            <p v-if="v$.accountForm.withdrawal_password.$error" class="error_cl">{{ $t('please-enter-withdraw-password', 'Please Enter Withdraw Password') }}</p>
                        </div>
                        <a href="javascript:void(0)" class="blue-link" @click="openWithdrawPassModal()">{{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?</a>
                    </div>
                    <div class="header-but info-footer">
                        <button type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal" @click="clearError()">{{$t('cancel','Cancel')}}</button>
                        <a class="thm-but" @click="addAccountServiceCall()">{{$t('save','Save')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import { addAccount, openWithdrawPasswordModal} from "../services/withdrawAccountDetails"
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const ifscValidator = helpers.withMessage(
  "Invalid IFSC Code format. It should be 11 alphanumeric characters like 'SBIN0001234'.",
  (value) => {
    if (!value) return true
    return /^[a-zA-Z0-9]{11}$/.test(String(value))
  }
)
const upiValidator = helpers.withMessage(
  "Must be in the format of 'name@bank.'",
  (value) => {
    if (!value) return true
    return /^[A-Za-z0-9-]+@[A-Za-z0-9]+$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, hyphens, underscores, or @.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9_@-]+$/.test(String(value))
  }
)
export default {
    name: 'AddBankAccount',
    setup() {
		return { v$: useVuelidate() }
	},
    inject: ['onlyBank','walletConfig'],
    props: ['paymentMethodList'],
    emits:['getAccountDetailList'],
    data() {
        return {
            loading: false,
            paymentMethodId: null,
            bankDetailsList: null,
            accountForm: {
				bankId: null,
				account_holder_name: '',
				account_no: '',
				ifsc_code: '',
				upi_id: '',
				wallet_id: '',
				qr_code: null,
                withdrawal_password: null
			},
            passwordFieldType: 'password',
            searchBank:null,
            selectedBank:null,
            onlyBankStatus: false,
            previewImageUtr: null,
            type:''
        }
    },
    computed: {
        filteredBankList() {            
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.walletConfig?.bank_list?.filter(item => item?.bank_name?.toLowerCase()?.includes(searchTermLower));
            }
            return this.walletConfig?.bank_list
        }
    },
    validations() {
        return {
            accountForm: {
                bankId: this.type === 'bank' ? { required } : {},
                account_holder_name: { required, minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName },
                account_no: this.type === 'bank' ? { 
                    required, 
                    minLength: minLength(9),
                    maxLength: maxLength(18) } : {},
                ifsc_code: this.type === 'bank' ? { required, ifscValidator } : {},
                upi_id: this.type === 'upi' ? {
                    minLength: minLength( 5 ),
                    maxLength: maxLength( 50 ),
                    upiValidator  } : {},
                wallet_id: this.type === 'wallet' ? { 
                    required,
                    required,
                    minLength: minLength( 8),
                    maxLength: maxLength( 20),
                    walletValidator } : {},
                withdrawal_password: { required },

            }
        };
    },
    methods: {
        clearPaymentSlip() {
            this.previewImageUtr = null;
            this.accountForm.qr_code = undefined;
            this.loading = false;
        },
        selectBank(item){
            this.accountForm.bankId = item.id
            this.accountForm.method_id = item.id;
            this.selectedBank = item.bank_name
        },
        onPaymentMethodChange() {
            this.clearForm();
            const selectedItem = this.paymentMethodList.find(item => item.id === this.paymentMethodId);
            this.getPaymentMethodItem(selectedItem);
            this.accountForm = {
                ...this.accountForm,
                account_holder_name: '',
                account_no: '',
                ifsc_code: '',
                upi_id: '',
                wallet_id: '',
                qr_code: null
            };
            this.previewImageUtr = null
        },
        getPaymentMethodItem(item) {
            this.type = item?.method_type;
            this.accountForm.method_id = item.id;
		    this.accountForm.paymentTypeName = item.method_name;
        },
        async addAccountServiceCall() {       
            this.v$.$touch()
            if (this.v$.$error) {
                return
            } else {
                if(this.type === 'upi' && this.accountForm.upi_id == '' && this.accountForm.qr_code == null){
                    this.$errorToast('At least one field is required UPI ID or QR code.')
                    return false;
                }
                const selectedItem = this.paymentMethodList.find(item => item.id === this.paymentMethodId);
                if(this.accountForm.wallet_id) this.accountForm.upi_id = this.accountForm.wallet_id
                let response = await addAccount(selectedItem, this.type, this.accountForm, this.accountForm)
                if(response){
                    this.clearError();
                    this.$helper.closeModal('acc-open-model');
                    this.$emit('getAccountDetailList');
                }
            }
        },
        fileUpdateFunc(event) {
            this.accountForm.qr_code = event.target.files[0];
            if (!this.accountForm.qr_code.type.startsWith('image/')) {
                event.target.value = "";
                this.accountForm.qr_code = null;
                this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                return;
            }
            const maxFileSize = 5 * 1024 * 1024; 
            if (this.accountForm.qr_code.size > maxFileSize) {
                this.accountForm.qr_code = null;
                this.$errorToast(`Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.`)
                return
            }  
            this.previewImageUtr = URL.createObjectURL(this.accountForm.qr_code);
        },
        clearForm(){
            this.accountForm = {
				bankId: null,
				account_holder_name: '',
				account_no: '',
				ifsc_code: '',
				upi_id: '',
				wallet_id: '',
				qr_code: null
			},
            this.previewImageUtr = null,
            this.type = null,
            this.errors = {};
            this.selectedBank = null;
            this.searchBank=null,
            this.v$.$reset();
            this.passwordFieldType = 'password'
        },
        clearError() {
            this.clearForm()
            this.paymentMethodId = null
        },
        async openWithdrawPassModal() {
            this.$emit('open-withdraw-password-modal');
        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        }
    }
}
</script>